/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc */

	/**
	 * NewsTicker
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class NewsTicker
	 * @extends Tc.Module
	 */
	Tc.Module.NewsTicker = Tc.Module.extend({

		on: function(callback) {
			var mod = this;
			
			mod.initnewsticker();

			callback();
		},

		/**
		 * get data from json file
		 */
		initnewsticker: function() {
			var mod = this,
				$ctx = mod.$ctx,
				cleanUrl = mod.stripParametersFromUrl(document.location.href),
				queryParams = null,
				newValues = [],
				i = null;


			mod.url = cleanUrl.substr(0, cleanUrl.lastIndexOf('.')) + '.pressreleaseservlet.json';
			mod.entriesPerPage = $ctx.data('num');
			mod.currentValues = {};
			mod.currentValues.num = {name:'num', valueObj: {labels:['none'], values: [$ctx.data('num')]}};
			// add one more result to the request to check if the "more"-button should be displayed
			mod.currentValues.num.valueObj.values[0]++; 

			mod.currentValues.offset = {name:'offset', valueObj: {labels:['none'], values: [$ctx.data('offset')]}};
			mod.currentValues.lang = {name:'lang', valueObj: {labels:['none'], values: [$ctx.data('lang')]}};
			mod.currentValues.categories = {name:'categories', valueObj: {labels:$ctx.data('categories').split(','), values: $ctx.data('categories').split(',')}};

			mod.currentData = [];

			queryParams = mod.getParametersFromUrl(document.location.href);
			if (queryParams && queryParams.categories) {
				mod.currentValues.categories = {name:'categories', valueObj: {labels:queryParams.categories.replace(/_8725_/g, '/').split(','), values: queryParams.categories.replace(/_8725_/g, '/').split(',')}};
			}

			if (mod.currentValues.categories && mod.currentValues.categories.valueObj && mod.currentValues.categories.valueObj.values && mod.currentValues.categories.valueObj.values.length > 0) {
				for (i = 0; i < mod.currentValues.categories.valueObj.values.length; i++) {
					newValues.push({ name : mod.currentValues.categories.name, label : mod.currentValues.categories.valueObj.labels[i], value : mod.currentValues.categories.valueObj.values[i] });
				}
				mod.fire('setFilters', {newValues: newValues});
			}


			$ctx.find('.more-results').on('click', '', function() {
				mod.loadData(true);
				return false;
			});

			mod.loadData(null);
		},

		onUpdateValue: function(data) {
			var mod = this;

			mod.currentValues[data.name] = data;

			// make sure that for multiple updates that are very shortly after each other are handled together (less ajax requests on clear all)
			if (mod.updateTimeout) {
				window.clearTimeout(mod.updateTimeout);
			}
			mod.updateTimeout = window.setTimeout(function() {
				mod.loadData();
			}, 50);
		},

		onLoadData: function() {
			this.loadData();
		},

		loadData: function(more) {
			var mod = this,
				$ctx = mod.$ctx,
				url = mod.url,
				request = null,
				clearCurrentView = false,
				extension = '',
				key = null;

			if (more) {
				mod.currentValues.offset.valueObj.values[0] += mod.entriesPerPage;
			}
			else {
				// no offset given - start search from 0
				clearCurrentView = true;
				mod.currentValues.offset.valueObj.values[0] = 0;
				mod.currentValues.num.valueObj.values[0] = mod.entriesPerPage + 1; // +1 to see if there are more results => display more button
			}

			extension = url.substr(url.lastIndexOf('.') + 1);
			url = url.substr(0, url.lastIndexOf('.'));

			if (mod.currentValues) {
				for (key in mod.currentValues) {
					if (mod.currentValues[key].valueObj === undefined) {
						continue;
					}
					else {
						url += '.' + mod.currentValues[key].name + '=' + mod.currentValues[key].valueObj.values.join(',').replace(/\//g, '_8725_');
					}
				}
			}

			url += '.' + extension;
			
			if (request !== null && request.readystate !== 4 && request.abort !== undefined) {
				request.abort();
			}

			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				success: function(data) {
					
					var showMoreLink = false,
						dataToDisplay = data,
						$html = null,
						tempYear,
						tempMonth;

					// requested are always mod.entriesPerPage + 1 to see if there are still more items available => display more button
					if (dataToDisplay.length > mod.entriesPerPage) {
						showMoreLink = true;
						dataToDisplay = dataToDisplay.slice(0, mod.entriesPerPage);
					}


					// add quarter to data
					for (var i = 0; i < dataToDisplay.length; i++) {
						
						if (dataToDisplay[i].date && dataToDisplay[i].date.length === 10) {
							tempYear = dataToDisplay[i].date.substr(6);
							tempMonth = parseInt(dataToDisplay[i].date.substr(3, 2), 10) - 1;
							dataToDisplay[i].quarter = tempYear + " Q" + (Math.floor(tempMonth / 3) + 1);
						}
						else {
							dataToDisplay[i].quarter = '-';
						}
					}

					if (clearCurrentView) {
						mod.currentData = [];
					}
					mod.currentData = mod.currentData.concat(dataToDisplay);

					mod.tmplItem = doT.template($('script.tmpl-newsticker', $ctx).html());
					$html = $(mod.tmplItem(mod.currentData));


					mod.$ctx.find('div.news-list-holder').html($html);

					if (showMoreLink) {
						$ctx.find('.more-results').show();
					}
					else {
						$ctx.find('.more-results').hide();
					}

				},

				error: function () {
					debug.log('Tc.Module.NewsTicker > data ajax error');
				}
			});
			
		},

		onSearch: function(data) {
			
			var mod = this;
			mod.currentValues.fulltext = {name:'fulltext', valueObj: {labels:['none'], values: [data.fulltext]}};
			mod.loadData();
		},

		stripParametersFromUrl: function(url) {
			var folderPath = url.substr(0, url.lastIndexOf('/')+1),
				filePath = url.substr(url.lastIndexOf('/')+1),
				query = '',
				newFilePath = '';
			if (url.indexOf('?') !== -1) {
				query = url.substr(url.indexOf('?'));
				filePath = filePath.substr(0, filePath.indexOf('?'));
			}
			newFilePath = filePath.substr(0, filePath.indexOf('.')) + filePath.substr(filePath.lastIndexOf('.'));
			return folderPath + newFilePath + query;

		},

		getParametersFromUrl: function(url) {
			var filePath = url.substr(url.lastIndexOf('/')+1),
				parameterPart = filePath.substr(filePath.indexOf('.') + 1),
				paramArray = '',
				data = {},
				i = 0,
				tempArr = null;

			parameterPart = parameterPart.substr(0, parameterPart.lastIndexOf('.'));
			paramArray = parameterPart.split('.');

	 		for (i; i < paramArray.length; i++) {
				tempArr = paramArray[i].split('=');
				if (tempArr.length === 2) {
					data[tempArr[0]] = tempArr[1];
				}
			}

			return data;
		}
	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.NewsTicker.js
// module id = 156
// module chunks = 0